const CONSTS = {
    imliveWmaster: 'https://imlive.com/wmaster2.ashx',
    imliveWmaster99: 'https://www99.imlive.com/wmaster2.ashx',
    directLinkHandler: '/services/directlinkhandler.ashx',
    imliveDomain: 'https://imlive.com',
    langImlive: 'https://lang.imlive.com',
    lpGen: 'https://23live.com',
    ptypeToLinkID: {
        1: 1128,
        2: 1174,
        13: 1293,
        14: 1299,
        15: 1305,
        22: 1317,
    },
    linkIDToPtype: {
        1128: 1,
        1174: 2,
        1293: 13,
        1299: 14,
        1305: 15,
        1317: 22,
    }
}

export default CONSTS;